import StatusBadge from '../StatusBadge';
import StatusCircles from '../StatusCircles';
import { useShownStatus } from '../../utils/undoableTicketStatus';
import type { MilestoneStatus } from '../../types';

/**
 * D-263 (D-225 QX-443) - the status of a task row as ONE pill with a list, the same `StatusCircles`
 * (-> `StatusPillSelect`) as the task page: a pick saves at once, with no timer and without opening
 * the task. Without `onChange` (no permission, a completed or cancelled task) it is the plain badge.
 * The status waiting in its 6 s "ביטול" window is shown at once (`useShownStatus`).
 */
export default function TaskStatusPill({ taskId, status, title, onChange }: {
  taskId: string;
  status: string;
  title: string;
  onChange?: (next: MilestoneStatus) => void;
}) {
  const shown = useShownStatus(taskId, status);
  if (!onChange) return <StatusBadge status={shown as any} />;
  // `dt-above`: the pill sits over the row's link, so a click opens the list and not the task.
  return (
    <span className="dt-above inline-flex" data-testid="task-status-pill">
      <StatusCircles status={shown} onChange={onChange} label={title} />
    </span>
  );
}
